import { useEffect } from 'react';
import styles from './MapAbout.module.scss';
import DG from '2gis-maps';

import iconMarker from '../../../../../images/map_marker.svg';

const MapAbout = () => {
  let screenWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    screenWidth = window.innerWidth;
    return screenWidth;
  });

  useEffect(() => {
    let map = DG.map('map', {
      center: [56.015072, 92.855779],
      zoom: 15,
    });

    let icon = DG.icon({
      iconUrl: iconMarker,
      iconSize: [30, 30],
    });

    DG.marker([56.014438, 92.853326], { icon: icon })
      .addTo(map)
      .bindPopup('<p>     Мы здесь</p><span>Обороны 3, офис 301</span>')
      .openPopup();
    return () => map.remove();
  }, []);

  return (
    <div className={styles.map}>
      <div
        id="map"
        className="default"
        style={{
          width: '100%',
          height: screenWidth > 768 ? 400 : 200,
        }}
      />
      <p>56.014438, 92.853326</p>
    </div>
  );
};

export default MapAbout;
